export type ExperienceMode = 'mobile' | 'pad' | 'desktop';

/** Floating-dock vs header behaviour: see `webdesignedDockPolicy.ts` (do not branch ad hoc in components). */

/** Must stay in sync with `WebDesignedPortal` resize + QA device frames. */
export const WEBDESIGNED_VIEWPORT = {
  /** Widths strictly below this use mobile shell (05B). */
  MOBILE_MAX_BELOW: 744,
  /** Widths from MOBILE_MAX_BELOW through this (inclusive) use pad shell (05C). */
  PAD_MAX_INCLUSIVE: 1366,
  /**
   * First width (px) for desktop shell — Login / Book / VUM live in the floating dock.
   * Keep in sync with `resolveExperienceMode` desktop branch.
   */
  DESKTOP_MIN_WIDTH_PX: 1367,
} as const;

export function resolveExperienceMode(viewportWidth: number): ExperienceMode {
  if (viewportWidth < WEBDESIGNED_VIEWPORT.MOBILE_MAX_BELOW) return 'mobile';
  if (viewportWidth <= WEBDESIGNED_VIEWPORT.PAD_MAX_INCLUSIVE) return 'pad';
  return 'desktop';
}

/**
 * Layout tier for cart assistant and other subsystems that still use phone/tablet/desktop naming.
 * Aligned with {@link resolveExperienceMode} (replaces ad-hoc 768/1024 splits).
 */
export function webdesignedLayoutTier(viewportWidth: number): 'phone' | 'tablet' | 'desktop' {
  const m = resolveExperienceMode(viewportWidth);
  if (m === 'mobile') return 'phone';
  if (m === 'pad') return 'tablet';
  return 'desktop';
}

